export enum SocietyTypes {
  HOUSING_COOPERATIVE = 'housing_cooperative',
  HOUSING_COOPERATIVE_CONSTRUCTION = 'housing_cooperative_construction',
  HOME_OWNERS_ASSOCIATION = 'homeowners_association',
  NON_PROFIT_ASSOCIATION = 'non_profit_association',
  ECONOMIC_ASSOCIATION = 'economic_association',
  NEIGHBOURHOOD = 'neighbourhood',
  APARTMENT_BUILDING = 'apartment_building',
}
